import {
  SERVICE_HOLDER_CARETAKER_ADAPT_ALREADY_HAD,
  SERVICE_HOLDER_CARETAKER_ADAPT_DIDNT_HAVE_BUT_WANT_TO,
  SERVICE_HOLDER_CARETAKER_ADAPT_NOT_WANT_TO_ACCEPT_IT,
  SERVICE_HOLDER_CARETAKER_ADAPT_RETICENT_BUT_WILL_TRY,
} from "./serviceHolder";

const options = [
  {
    value: SERVICE_HOLDER_CARETAKER_ADAPT_ALREADY_HAD,
  },
  {
    value: SERVICE_HOLDER_CARETAKER_ADAPT_NOT_WANT_TO_ACCEPT_IT,
  },
  {
    value: SERVICE_HOLDER_CARETAKER_ADAPT_RETICENT_BUT_WILL_TRY,
  },
  {
    value: SERVICE_HOLDER_CARETAKER_ADAPT_DIDNT_HAVE_BUT_WANT_TO,
  },
];

export function caretakerOptionsList() {
  return options;
}
